import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CreateTest from './pages/CreateTest';
import CreateTemplate from './pages/CreateTemplate';
import ConfigureTest from './pages/ConfigureTest';
import DetailedTestConfiguration from './pages/DetailedTestConfiguration';
import EditDetailedTest from './pages/EditDetailedTest';
import ConfigureTemplate from './pages/ConfigureTemplate';
import MyTests from './pages/MyTests';
import AnswerTest from './pages/AnswerTest';
import StudentAnswerTest from './pages/StudentAnswerTest';
import ShareTest from './pages/ShareTest';
import TestResults from './pages/TestResults';
import ManualEntry from './pages/ManualEntry';
import PhotoValidation from './pages/PhotoValidation';
import CameraScannerPage from './pages/CameraScannerPage';
import BatchValidationPage from './pages/BatchValidationPage';
import ProfileSettings from './pages/ProfileSettings';
import HealthCheck from './pages/HealthCheck';
import UsersPage from './pages/UsersPage';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Route publique - Page d'inscription */}
        <Route path="/signup" element={<SignupPage />} />

        {/* Route publique - Page de connexion */}
        <Route path="/login" element={<LoginPage />} />

        {/* Route publique - Page mot de passe oublié */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* Route publique - Page de réinitialisation du mot de passe */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Route publique - Health Check */}
        <Route path="/health" element={<HealthCheck />} />


        {/* Route protégée - Créer un nouveau test */}
        <Route
          path="/create-test"
          element={
            <PrivateRoute>
              <Layout>
                <CreateTest />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Créer un nouveau template */}
        <Route
          path="/create-template"
          element={
            <PrivateRoute>
              <Layout>
                <CreateTemplate />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Configurer le test */}
        <Route
          path="/configure-test"
          element={
            <PrivateRoute>
              <Layout>
                <ConfigureTest />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Configuration détaillée du test */}
        <Route
          path="/detailed-test-configuration"
          element={
            <PrivateRoute>
              <Layout>
                <DetailedTestConfiguration />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Édition d'un test détaillé */}
        <Route
          path="/edit-detailed-test/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <EditDetailedTest />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Configurer le template */}
        <Route
          path="/configure-template"
          element={
            <PrivateRoute>
              <Layout>
                <ConfigureTemplate />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Mes tests (route par défaut après connexion) */}
        <Route
          path="/my-tests"
          element={
            <PrivateRoute>
              <Layout>
                <MyTests />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Saisir les réponses d'un test */}
        <Route
          path="/answer-test/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <AnswerTest />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route publique - Répondre au test (étudiant) - Sans header sur mobile */}
        <Route
          path="/student-answer-test/:testId"
          element={<StudentAnswerTest />}
        />

        {/* Route protégée - Partager un test */}
        <Route
          path="/share-test/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <ShareTest />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Voir les résultats d'un test */}
        <Route
          path="/test-results/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <TestResults />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Saisie manuelle des résultats */}
        <Route
          path="/manual-entry/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <ManualEntry />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Validation photo OCR */}
        <Route
          path="/photo-validation/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <PhotoValidation />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Scanner caméra temps réel */}
        <Route
          path="/camera-scanner/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <CameraScannerPage />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Validation par lot des scans */}
        <Route
          path="/batch-validation/:testId"
          element={
            <PrivateRoute>
              <Layout>
                <BatchValidationPage />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Paramètres du profil */}
        <Route
          path="/profile-settings"
          element={
            <PrivateRoute>
              <Layout>
                <ProfileSettings />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Route protégée - Gestion des utilisateurs */}
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Layout>
                <UsersPage />
              </Layout>
            </PrivateRoute>
          }
        />

        {/* Page d'accueil - Choix étudiant/enseignant */}
        <Route path="/" element={<LandingPage />} />

        {/* Page 404 */}
        <Route path="*" element={<Navigate to="/my-tests" replace />} />
      </Routes>
    </Router>
  );
};

export default App;